var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhatsapp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#48C95F",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.756 7.238A6.26 6.26 0 0 0 12.322 5.4c-3.468 0-6.278 2.8-6.278 6.257 0 1.093.307 2.187.834 3.106L6 18l3.337-.875a6.4 6.4 0 0 0 2.985.744c3.468 0 6.278-2.8 6.278-6.256-.044-1.619-.659-3.194-1.844-4.375m-1.405 6.65c-.132.35-.746.7-1.053.744a2.5 2.5 0 0 1-.966-.044c-.22-.088-.527-.175-.878-.35-1.58-.656-2.59-2.231-2.678-2.363-.088-.087-.659-.83-.659-1.618s.395-1.138.527-1.313.307-.175.439-.175h.307c.088 0 .22-.044.351.263.132.306.44 1.093.483 1.137a.28.28 0 0 1 0 .263.9.9 0 0 1-.175.262c-.088.088-.176.219-.22.263-.088.087-.175.175-.088.306.088.175.396.656.879 1.094.614.525 1.097.7 1.273.787s.263.044.35-.044c.089-.087.396-.437.484-.612s.22-.131.351-.088c.132.044.922.438 1.054.525.175.088.263.132.307.175.044.132.044.438-.088.788"
})));
export default SvgWhatsapp;